(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-map"] && !Shopify.designMode) return;
  try {
    
  /* Placeholder for any additional JavaScript */

  } catch(e) { console.error(e); }
})();
})();
